<template>
    <section>
        <div v-if="state.currentView == 'ENAIRA_INIT_VIEW' && state.processing != true" class="payment__form">
            <h4 id="eNaira-options-heading" class="heading">{{ $t("enaira.option.title") }}</h4>

            <div
                role="listbox"
                aria-orientation="vertical"
                aria-labelledby="eNaira-options-heading"
                aria-roledescription="Select eNaira option"
            >
                <ul class="enaira-options">
                    <li 
                        v-for="option in state.eNairaPaymentOptions" 
                        :key="option.name"
                        class="enaira-option" 
                        :class="{ 'enaira-option-active': option.name === state.eNairaSelectedOption }"
                        role="option"
                        :aria-selected="option.name === state.eNairaSelectedOption"
                        :aria-label="`eNaira ${option.name} option`"
                    >

                        <div>
                            <label 
                                @click="setSelected(option.name)"
                                :for="option.name"
                                class="enaira-option__text" 
                                :class="{ is_selected: state.eNairaSelectedOption === option.name  }"
                            >

                                <input 
                                    type="radio" 
                                    class="check-custom"
                                    :id="option.name" 
                                    name="eNairaOptions"
                                    :value="option.name"
                                    :checked="state.eNairaSelectedOption === option.name"
                                >

                                <span class="check-toggle"></span>
                                {{ option.name }}
                            </label>
                            <p 
                                class="enaira-option__subtext"
                                @click="setSelected(option.name)"
                            >
                                {{ $t("enaira.pay.option")}}  {{ option.name.length > 10 ? option.name : `eNaira ${option.name}`  }} 
                            </p>
                        </div>
                    </li>
                </ul>
            </div>

            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                @click="Next"
            />
        </div>

        <div v-else-if="state.currentView == 'ENAIRA_OTP_VIEW' && state.processing !== true">
            <form @submit.prevent="checkDetails">
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("enaira.otp.instruction")}}
                </p>

                <div class="container__col-md-12 container__col-sm-12">
                    <primary-input
                        :title="$t('enaira.otp.input.phone')"
                        type="tel"
                        :number-only="true"
                        inputName="phone"
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="smart-phone"
                        placeholder="07013926478"
                        :defaultValue="
                            getValueFromPath(state, 'inputs.phone.value') || null
                        "
                        :isRequired="
                            getValueFromPath(state, 'inputs.phone.required') ||
                                true
                        "
                        @value-change="phone = $event"
                    />
                </div>

                <div class="container__col-md-12 container__col-sm-12">
                    <primary-input
                        :title="$t('enaira.otp.input.token')"
                        type="tel"
                        :number-only="true"
                        inputName="otp"
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="lock-icon"
                        placeholder="123456"
                        :defaultValue="
                            getValueFromPath(state, 'inputs.otp.value') || null
                        "
                        :isRequired="
                            getValueFromPath(state, 'inputs.otp.required') ||
                                true
                        "
                        @value-change="otp = $event"
                    />
                </div>

                <div class="notif-box">
                    <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.658.388a4.658 4.658 0 1 0 0 9.317 4.658 4.658 0 0 0 0-9.317Zm.97 7.22c-.24.094-.43.166-.574.216-.143.05-.309.074-.498.074-.29 0-.516-.07-.677-.212a.686.686 0 0 1-.24-.54c0-.084.005-.171.017-.26.012-.088.032-.187.058-.299l.3-1.06c.027-.102.05-.198.068-.288.018-.09.026-.174.026-.25 0-.135-.028-.23-.083-.282-.057-.054-.163-.08-.32-.08a.841.841 0 0 0-.24.036 3.39 3.39 0 0 0-.208.07l.08-.327c.196-.08.384-.149.563-.206.18-.057.35-.086.509-.086.288 0 .51.07.667.21.156.138.234.32.234.542 0 .046-.005.127-.016.243-.01.117-.03.223-.06.32l-.298 1.057a2.988 2.988 0 0 0-.066.29c-.02.109-.029.191-.029.247 0 .14.031.236.094.287.063.051.172.077.327.077a1.404 1.404 0 0 0 .446-.105l-.08.325Zm-.053-4.29a.712.712 0 0 1-.503.194.72.72 0 0 1-.505-.194.62.62 0 0 1-.21-.47c0-.184.071-.342.21-.473.14-.13.31-.196.505-.196.196 0 .364.066.503.196.14.131.21.289.21.472 0 .184-.07.341-.21.47Z" fill="#F5A623"/></svg>

                    <p class="notif">{{ $t("enaira.otp.notif")}}</p>
                </div>

                <PrimaryButton
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    type="submit"
                    :disabled="!hasCompletedFields || state.processing"
                />
            </form>

            <div class="cancel-option">
                <p @click="cancelOption">{{ $t("enaira.option.switch") }}</p>
            </div>
        </div>

        <div v-else-if="state.currentView == 'REDIRECT_VIEW' && state.processing != true ">
            <RedirectView @next="Next" />


            <div class="cancel-option">
                <p @click="cancelOption">{{ $t("enaira.option.switch") }}</p>
            </div>
        </div>

        <div v-else-if="
            state.currentView == 'ENAIRA_QR_VIEW' && 
                state.processing != true &&
                !showProcessing
        " 
        >
            <div class="payment__body__success-img">
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ state.instruction }}
                </p>
                <figure class="qr-code">
                    <img
                        :src="state.qrCode"
                        alt="qr code"
                        class="container__col-sm-12 container__col-md-12 qr-code__img"
                        loading="lazy" 
                        decoding="async"
                    />
                </figure>
                <PrimaryButton
                    :content="$t('enaira.transaction.complete.btn')"
                    @click="toggleProcessing"
                />
            </div>


            <div class="cancel-option">
                <p @click="cancelOption">{{ $t("enaira.option.switch") }}</p>
            </div>
        </div>

        <template
            v-else-if="
                state.currentView == 'ENAIRA_QR_VIEW' &&
                    state.processing != true &&
                    showProcessing
            "
        >
            <payment-loading />
        </template>

        <template v-else-if="state.currentView == 'CONFIRMING_VIEW' && state.processing != true">
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("enaira.transaction.status")}}
            </p>

            <div class="center">
                <div class="loader-icon"></div>
            </div>
        </template> 

    </section>
</template>

<script>
import { ref, onBeforeUnmount, computed } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
import RedirectView from "@/components/common/redirect-view";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
import PaymentLoading from "@/components/payment-loading.vue";


export default {
    name: "ENaira",

    components: {
        RedirectView,
        PrimaryButton,
        PrimaryInput,
        PaymentLoading,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const showProcessing = ref(false);
        const phone = ref("");
        const otp = ref("");
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        const hasCompletedFields = computed(() => {
            return !!phone.value && !!otp.value;
        });

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
            showProcessing.value = false;
        }

        function cancelOption() {
            checkoutData.value.view.context.resetView();
        }

        function setSelected(tab) {
            if (tab.target) {
                const selected = tab.target.value;
                checkoutData.value.view.context.$actions.update({ eNairaPaymentOption: selected });
            } 
            else {
                checkoutData.value.view.context.$actions.update({ eNairaPaymentOption: tab });
            }
        }

        function checkDetails() {
            if (hasCompletedFields.value) {
                const data = {
                    phone: phone.value,
                    otp: otp.value,
                };

                submitData(data);
            }
        }

        function submitData(data) {
            if (data) {
                checkoutData.value.view.context.$actions.update(data);
                setTimeout(() => {
                    checkoutData.value.view.context.$actions.next();
                }, 0);
            }
        }

        function toggleProcessing() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);            
            showProcessing.value = true;
        }

        // const autoInitializePayment = autoInitialize("ENAIRA_INIT_VIEW");

        // onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        onBeforeUnmount(() => {
            subscription();
        });

        // watch(() => checkoutData.value.view.current, (newVal) => {
        //     if (newVal == "ENAIRA_QR_VIEW") {
        //         Next();
        //     }
        // });

        return {
            state: mapState({
                amount: (state) => getValueFromPath(state, "amount") || null,
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs"),
                instruction: (state) => getValueFromPath(state, "view.context.instruction"),
                eNairaPaymentOptions: (state) => 
                    getValueFromPath(state, "view.context.inputs.eNairaPaymentOption.options") || [],
                eNairaSelectedOption: (state) => 
                    getValueFromPath(state, "view.context.inputs.eNairaPaymentOption.value.name") || null,
                qrCode: (state) =>
                    getValueFromPath(state, "view.context.qrcode") || null,
            }),
            checkoutData,
            getValueFromPath,
            phone,
            setSelected,
            otp,
            hasCompletedFields,
            checkDetails,
            showProcessing,
            toggleProcessing,
            cancelOption,
            Next,
        };
    },
};
</script>

<style scoped lang="scss">
    .heading {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #000;
        margin-bottom: 25px;
        margin-top: 15px;
    }

    .cancel-option {
        text-align: center;
        margin-top: 2rem;
        cursor: pointer;
        
        p {
            color: $primary-color;
            font-size: 14px;
            font-weight: 500;
        }
    }

    input[type='radio'].check-custom {
        position: absolute;
        left: -10000px;
        top: auto;
        width: 1px;
        height: 1px;
        overflow: hidden;
    }

    input[type='radio'].check-custom ~ .check-toggle {
        width: 2.4rem;
        height: 2.4rem;
        position: relative;
        display: inline-block;
        vertical-align: middle;
        border: 2px solid #E0E0E0;
        border-radius: 50%;
        cursor: pointer;
        margin-right: 23px;
    }

    input[type='radio'].check-custom:hover ~ .check-toggle {
        border-color: #4a4a4a;
    }

    input[type='radio'].check-custom:focus ~ .check-toggle {
        border-color: #E0E0E0;
        box-shadow: 0 0 0 2px #E0E0E0;
    }

    input[type='radio'].check-custom:checked ~ .check-toggle {
        border: none;
        background: $primary-color url("../../assets/icons/black-tick.svg") center no-repeat;
        background-size: 65%;
    }

    .enaira-options {
        display: flex;
        flex-direction: column;
        margin-bottom: 1.2rem;

        .enaira-option {
            display: flex;
            margin-bottom: 20px;
            box-sizing: border-box;
            cursor: pointer;

            &__text {
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 15px;
                cursor: pointer;
            }

            &__subtext {
                margin-top: 6px;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: $secondary-text-color;
                margin-left: 5.2rem;
            }

            .is_selected {
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 15px;
                color: $primary-color;
            }
        }
    }
    
    .notif-box {
        background: #FFF9E8;
        border: 0.912602px solid #E0E0E0;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding: 8px 10px;
        position: relative;
        bottom: 2.3rem;
    }

    .notif {
        font-style: normal;
        font-weight: 400;
        font-size: 1.4rem;
        line-height: 1.4rem;
        letter-spacing: 0.3px;
        color: #4e4d4d;
        display: inline;
        margin-left: 1.17rem;
    }

    .qr {
        display: flex;
        // height: 500px;
        flex-direction: column;
    }
    .qr-visa {
        width: 60%;
        margin: 0 auto;
        margin-bottom: 10px;
        &__img {
            width: 100%;
            height: 50px;
            object-fit: cover;
            object-position: 5% 0%;
        }
    }
    .qr-code {
        width: 70%;
        overflow: hidden;
        margin: 0 auto;
        &__img {
            width: 100%;

            object-fit: cover;
            object-position: 0% 100%;
            image-rendering: pixelated;
            @media screen and (max-width: 320px) {
                height: 180px;
            }
            @media screen and (min-width: 360px) and (max-width: 375px) {
                height: 200px;
            }
            @media screen and (min-width: 375px) and (max-width: 420px) {
                height: 230px;
            }
            @media screen and (min-width: 421px) {
                height: 250px;
            }
            @media screen and (min-width: 768px) and (max-width: 1024px) {
                height: 230px;
            }
        }
    }
</style>